import { memo, useCallback, useContext } from 'react';

import { UploadContext } from '@air/component-upload-dropzone';
import { FolderUpIcon, PlusIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { useBreakpointsContext } from '@air/provider-media-query';

export const ContentCollectionOnboardingEmptyState = memo(() => {
  const { isAboveMediumScreen } = useBreakpointsContext();

  const { openUploader } = useContext(UploadContext);

  const openFilesUploader = useCallback(() => {
    openUploader({ type: 'files' });
  }, [openUploader]);

  const openFoldersUploader = useCallback(() => {
    openUploader({ type: 'folders' });
  }, [openUploader]);

  return (
    <div className="absolute bottom-0 flex w-full flex-col gap-2 ads:border-default border-gray-4 border-t ads:bg-base bg-gray-1 p-4 shadow-kanban md:static md:max-w-[300px] md:border-0 md:ads:bg-transparent md:bg-transparent md:p-0 md:shadow-none">
      <Button
        className="rounded-8"
        color="blue"
        data-testid="CONTENT_COLLECTION_ONBOARDING_EMPTY_STATE_UPLOAD_FILES_BUTTON"
        onClick={openFilesUploader}
        prefix={<PlusIcon size="md" />}
        size="extra-large"
      >
        Add files
      </Button>
      {isAboveMediumScreen && (
        <>
          <Button
            className="rounded-8"
            color="gray"
            data-testid="CONTENT_COLLECTION_ONBOARDING_EMPTY_STATE_UPLOAD_FOLDER_BUTTON"
            onClick={openFoldersUploader}
            prefix={<FolderUpIcon size="md" />}
            size="extra-large"
          >
            Add a folder
          </Button>
          <span className="text-center ads:text-metadata text-12 text-gray-9">or drag and drop here</span>
        </>
      )}
    </div>
  );
});

ContentCollectionOnboardingEmptyState.displayName = 'ContentCollectionOnboardingEmptyState';
